module.exports = __webpack_public_path__ + "static/media/Roseto - Sand_DK Grey.bb9d88b6.jpg";